<template>
  <div id="main-content" class="admin-notification-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="notificationDetail">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.title') }}:</span>
            <span class="info-span"> {{ notificationDetail.title }} </span>
          </el-col>
          <el-col :span="24" class="content-row">
            <span class="form-lable">{{ $t('common.content') }}:</span>
            <span class="info-span"> {{ notificationDetail.content }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('notification.send_type') }}:</span>
            <span class="info-span"> {{ getSendType(notificationDetail.send_type) }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.time') }}:</span>
            <span class="info-span">{{ $moment(notificationDetail.created_at).format('YYYY-MM-DD h:mm:ss') }}</span>
          </el-col>
        </el-row>
        <el-row class="row-section">
          <h3>{{ $t('parent_list.parent_list') }}</h3>
        </el-row>
        <el-row>
          <table class="bus-list">
            <tr>
              <th width="5%">#</th>
              <th>{{ $t('common.full_name') }}</th>
            </tr>
            <tr v-for="(parent, index) in notificationDetail.parent_list" :key="parent.id">
              <td>{{ index + 1 }}</td>
              <td>{{ parent.name }}</td>
            </tr>
          </table>
        </el-row>
        <el-divider></el-divider>
        <el-row class="row-section">
          <h3>{{ $t('sub_driver.sub_driver_list') }}</h3>
        </el-row>
        <el-row>
          <table class="bus-list">
            <tr>
              <th width="5%">#</th>
              <th>{{ $t('common.full_name') }}</th>
            </tr>
            <tr v-for="(subDriver, index) in notificationDetail.sub_driver_list" :key="subDriver.id">
              <td>{{ index + 1 }}</td>
              <td>{{ subDriver.name }}</td>
            </tr>
          </table>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import { SEND_TYPE_PUSH, SEND_TYPE_MAIL } from '@/config'

  export default {
    name: "DetailAdminNotification",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'notification.notification_information',
        backLink: `/admin-notification?action=back`,
        notificationDetail: null
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.notificationDetail = Object.assign({}, response.data.data.notification_info)
      };
      let payload = {
        successCallback,
        id: this.$route.query.id
      }
      this.$store.dispatch('notification/retrieveAdminNotificationDetail', payload)
    },
    computed: {

    },
    methods: {
      getSendType (sendType) {
        switch (sendType) {
          case SEND_TYPE_PUSH:
            return this.$t('notification.push_notification')
          case SEND_TYPE_MAIL:
            return this.$t('common.email')
          default:
            return this.$t('common.both')
        }
      }
    }
  }
</script>

<style lang="scss">
  .admin-notification-detail {
    .content-row {
      .info-span {
        display: block;
        width: calc(100% - 94px);
        text-align: left;
      }
    }
  }
</style>